import { BaseService } from '@/core/base-service';

export default class TimeLineAdminService extends BaseService<any> {
	public constructor() {
		super('services/servicepze/api/admin/time-line');
	}
}
